import { render, staticRenderFns } from "./proformaEdit.vue?vue&type=template&id=99f4ce0e"
import script from "./proformaEdit.vue?vue&type=script&lang=js"
export * from "./proformaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports